/**
 * Shared formatting for multi-item bundle lines (mig 0061).
 * Accepts both plan-item shapes ({quantity,minutes,creditCents}) and
 * purchased-item shapes ({totalQuantity,totalMinutes,totalCreditCents}).
 */
export interface BundleItemLike {
  kind: string;
  tierName?: string | null;
  quantity?: number | null;
  minutes?: number | null;
  creditCents?: number | null;
  totalQuantity?: number | null;
  totalMinutes?: number | null;
  totalCreditCents?: number | null;
  /** vac_minutes only: must be used in a single session. */
  allAtOnce?: boolean | null;
}

/** "3× Premium washes · 30 vac min · $5.00 vending" — null when no items. */
export function bundleItemsSummary(items: BundleItemLike[] | null | undefined): string | null {
  if (!items || items.length === 0) return null;
  const parts = items.map(i => {
    if (i.kind === 'wash') {
      const qty = i.quantity ?? i.totalQuantity ?? 0;
      return `${qty}× ${i.tierName || 'wash'} wash${qty === 1 ? '' : 'es'}`;
    }
    if (i.kind === 'vac_minutes') {
      return `${i.minutes ?? i.totalMinutes ?? 0} vac min${i.allAtOnce ? ' (one session)' : ''}`;
    }
    if (i.kind === 'vending_credit') {
      return `$${(((i.creditCents ?? i.totalCreditCents ?? 0)) / 100).toFixed(2)} vending`;
    }
    return i.kind;
  });
  return parts.join(' · ');
}
